<script>
    import TableActionCell from "./TableActionCell.svelte";

    export let tableData; // [{ key:, title:, value: }]
</script>

{#if tableData.length > 0}
    <table class="general-table">
        <thead>
            <tr>
                {#each tableData[0] as x}
                    <th scope="col">{x.title}</th>
                {/each}
            </tr>
        </thead>
        <tbody>
            {#each tableData as data}
                <tr>
                    {#each data as x}
                        {#if ["Add", "Edit", "Remove"].includes(x.key)}
                            <TableActionCell
                                item={x.value}
                                action={x.key}
                                on:item-add
                                on:item-edit
                                on:item-remove
                            />
                        {:else}
                            <td>{x.value}</td>
                        {/if}
                    {/each}
                </tr>
            {/each}
        </tbody>
    </table>
{/if}

<style>
    .general-table {
        text-align: center;
        -webkit-border-vertical-spacing: 0;
        border-collapse: collapse;
        table-layout: auto;
        padding: 8px;
        width: 100%;
    }
</style>
